import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);
export const store = new Vuex.Store({

  state: {
      navshowState: true,
      language: JSON.parse(localStorage.getItem('language'))
  },
  mutations: {
      language(state, language){
          state.language = language,
          localStorage.setItem('language',language)
      },
      navshowState(state, navshowState ) {
          state.navshowState = navshowState
      }
  },
  getters: {
    language: state => state.language,
      navshowState: state => state.navshowState
  }
});
